// src/locales/en/messageCenterShiftLeaderCommission.js
export const messageCenterShiftLeaderCommission = {
  configureButton: 'Leader Commission',
  modalTitle: 'Shift Leader Commission Settings',
  enabled: 'Enable shift leader commission',
  calculationMethod: 'Calculation Method',
  perSalesValue: 'Per Sales Value',
  otherMethodsComingSoon: 'Per Order and Per Item calculation methods are coming soon.',
  calculationBase: 'Calculation Base',
  phaseCount: 'Number of Phases',
  phase: 'Phase',
  addTier: 'Add Tier',
  fixedAmount: 'Fixed Amount',
  targetValue: 'Target Value',
  shifts: 'Shifts',
  orders: 'Orders',
  products: 'Products',
  progress: 'Progress',
  saveSuccess: 'Shift leader commission settings saved successfully',
  saveFailed: 'Failed to save shift leader commission settings',
  viewPageTitle: 'Shift Leader Commission',
  viewPageDescription: 'Phase-based commission breakdown for shift leaders, by settlement month',
  monthTotal: 'Month Total',
  grandTotal: 'Grand Total',
  featureDisabled: 'Shift leader commission is not enabled for this business',
  noLeadersForMonth: 'No shift leaders led a shift in this month',
  failedToLoadReport: 'Failed to load shift leader commission report',
  enabledHelp: 'When off, leaders earn no phase commission. Any tiers entered are still validated.',
  phaseCountPlaceholder: 'e.g. 3',
  targetValuePlaceholder: 'e.g. 5500000',
  validation: {
    targetNegative: 'Target value cannot be negative',
    minValueInvalid: 'Each tier requires a valid, non-negative minimum value',
    maxValueRequired: 'Maximum value is required for every tier except the last',
    rateInvalid: 'Each tier requires a valid, non-negative rate',
    fixedAmountInvalid: 'Each tier requires a valid, non-negative fixed amount',
  },
};
